import { Context, createContext, useContext } from 'react';

/**
 * Where a menu item is currently being drawn.
 *
 * The same section is rendered in two places: down the sidebar itself, and
 * inside the flyout that a collapsed rail opens on hover. Almost everything
 * looks the same in both, but the group headings do not — they are hidden in a
 * 60px rail because there is no room for them, and they are the whole point of
 * the flyout, which is wide enough to show them.
 *
 * A component cannot tell those two cases apart from `useSidebarState` alone:
 * when the flyout is open the sidebar is, by definition, closed. Hence this.
 */
export type MenuSurface = 'rail' | 'flyout';

const MenuSurfaceContext: Context<MenuSurface> = createContext<MenuSurface>('rail');

export const MenuSurfaceProvider = MenuSurfaceContext.Provider;

export const useMenuSurface: () => MenuSurface = (): MenuSurface => useContext(MenuSurfaceContext);
